// extracted by mini-css-extract-plugin
export default {"inputContainer":"InputWithLabel_inputContainer__ELVI9","icon":"InputWithLabel_icon__RGmVD"};